<template>
    <div :style="`
        width: ${settings.layout.width ? settings.layout.width : 'auto'};
        margin-top: ${settings.layout.margin.top ? settings.layout.margin.top : '0px'};
        margin-right: ${settings.layout.margin.right ? settings.layout.margin.right : '0px'};
        margin-bottom: ${settings.layout.margin.bottom ? settings.layout.margin.bottom : '15px'};
        margin-left: ${settings.layout.margin.left ? settings.layout.margin.left : '0px'};
        box-shadow: ${settings.layout.box_shadow ? settings.layout.box_shadow : 'none'};
        border-radius: ${settings.layout.border_radius ? settings.layout.border_radius : '0px'};
        
    `">
        <a v-if="card.link" :href="card.link" aria-label="Banner">
            <img height="200" width="200" class="w-100" alt="" :src="card.banner"
                loading="lazy"
                :style="`
                    height: ${settings.layout.height ? settings.layout.height : 'auto'};
                    border-radius: ${settings.layout.border_radius ? settings.layout.border_radius : '0px'};
                    border: ${settings.layout.border ? settings.layout.border : 'none'} solid ${settings.layout.border_color ? settings.layout.border_color : ''};
                `"
            >
        </a>
        <img v-else height="200" width="200" class="w-100" alt="" :src="card.banner"
            loading="lazy"
            :style="`
                height: ${settings.layout.height ? settings.layout.height : 'auto'};
                border-radius: ${settings.layout.border_radius ? settings.layout.border_radius : '0px'};
                border: ${settings.layout.border ? settings.layout.border : 'none'} solid ${settings.layout.border_color ? settings.layout.border_color : ''};
            `"
        >
    </div>
</template>

<script>
export default {
    name: 'CardConfig',
    props: {
        card: {required:true, type:Object}
    },
    data() {
        return {
            settings: JSON.parse(this.card.settings)
        }
    }
}
</script>